import React, { ComponentType } from 'react';
import { matchPath } from 'react-router';

import { CommonPageData } from './CommonPageData';
import { EntityAccessManagementRoute, EntityAccessManagementRoutes } from './modules/accessManagement';
import { BillingManagementRoute, BillingManagementRoutes } from './modules/billingManagement';
import {
  BillingManagementClaimStepsRoute,
  BillingManagementClaimsStepsRoutes,
} from './modules/billingManagementClaimSteps';
import { DashboardRoute, DashboardRoutes } from './modules/dashboard';
import { DocumentsRoute, DocumentsRoutes } from './modules/documents';
import { ErrorRoute, ErrorRoutes } from './modules/errors';
import { OrderRoute, OrderRoutes } from './modules/order';
import { OthersRoute, OthersRoutes } from './modules/others';

export interface Route {
  path: string;
  exact: boolean;
  isInternal?: boolean;
  commonPageData: CommonPageData;
  component: ComponentType<any>;
  children?: Route[];
}

export enum DefaultRoute {
  Home = '/',
  Login = '/login',
  BillsToPay = '/2-2-1-1-1-4',
}

export const ROUTES = {
  ...DefaultRoute,
  ...EntityAccessManagementRoute,
  ...OrderRoute,
  ...DashboardRoute,
  ...DocumentsRoute,
  ...BillingManagementRoute,
  ...BillingManagementClaimStepsRoute,
  ...OthersRoute,
  ...ErrorRoute,
};

const routes: Route[] = [
  {
    path: DefaultRoute.Home,
    exact: true,
    component: React.lazy(() => import('../../views/pages/Home/Home')),
    commonPageData: { pageTitle: 'Testing page: Home' },
  },
  {
    path: DefaultRoute.Login,
    exact: true,
    component: React.lazy(() => import('../../views/pages/Home/Home')),
    commonPageData: { pageTitle: 'Testing page: Home' },
  },
  {
    path: DefaultRoute.BillsToPay,
    exact: false,
    component: React.lazy(() => import('../../views/pages/Billing/InvocesToPay/2.2.1.1.1.4_BillsToPay/BillsToPay')),
    commonPageData: { pageTitle: 'Šablona 2.2.1.1.1.4' },
  },
  ...EntityAccessManagementRoutes,
  ...OrderRoutes,
  ...DashboardRoutes,
  ...DocumentsRoutes,
  ...BillingManagementRoutes,
  ...BillingManagementClaimsStepsRoutes,
  ...OthersRoutes,
  ...ErrorRoutes,
];

/**
 * Finds the {@link Route definition of application route} by current URL path (i.e. window.location.pathname)
 */
export const getCurrentRoute = () => {
  return routes
    .filter((route: Route) => route.commonPageData.pageId !== '0.0.0')
    .find((route: Route) => !!matchPath(window.location.pathname, route));
};

export const isRouteActive = (route: string, location: any): boolean => {
  return location.pathname === route;
};

type RoutesKeys = keyof typeof ROUTES;

export type Routes = typeof ROUTES[RoutesKeys];
export default routes;
